import React from 'react';
import Divider from 'antd/lib/divider';
import 'antd/lib/divider/style/index.css';
import Col from 'antd/lib/grid/col';
import Row from 'antd/lib/grid/row';
import 'antd/lib/grid/style/index.css';
import Icon from 'antd/lib/icon';
import Tooltip from 'antd/lib/tooltip';
import 'antd/lib/tooltip/style/index.css';
import SwitchRoundFlagLocked from '../../ListRoundPage/SwitchRoundFlagLocked';
import SwitchRoundFlagFinalized from '../../ListRoundPage/SwitchRoundFlagFinalized';
import SwitchRoundFlagVisible from '../../ListRoundPage/SwitchRoundFlagVisible';
var tableStyles = require('src/imports/styles/extend.table.scss');
var InputStatus = function (props) {
    var round = props.round;
    return (round && round.id)
        ? (React.createElement(React.Fragment, null,
            React.createElement("span", null, "Changes to round status will be applied immediately - you do not need to click \"save\" for it to take effect."),
            React.createElement(Divider, null),
            React.createElement(Row, { gutter: 12, style: { paddingBottom: '8px' } },
                React.createElement(Col, { xs: 12, xl: 16, style: { textAlign: 'right' } },
                    React.createElement(Tooltip, { title: 'Locking scores for a round stop scores from being submitted by the judge app. You can still edit the scores on this platform.' },
                        React.createElement("h4", { style: { display: 'inline' } },
                            "Lock Round ",
                            React.createElement(Icon, { type: 'question-circle-o', className: tableStyles.headerIcon })))),
                React.createElement(Col, { xs: 12, xl: 8 },
                    React.createElement(SwitchRoundFlagLocked, { round: round, handlePatchRound: props.handlePatchRound }))),
            React.createElement(Row, { gutter: 12, style: { paddingBottom: '8px' } },
                React.createElement(Col, { xs: 12, xl: 16, style: { textAlign: 'right' } },
                    React.createElement(Tooltip, { title: 'Confirming scores for a round adds a label to the scoreboard to let your athletes and spectators know that the scores have been verified by the Chief Judge' },
                        React.createElement("h4", { style: { display: 'inline' } },
                            "Confirm Scores ",
                            React.createElement(Icon, { type: 'question-circle-o', className: tableStyles.headerIcon })))),
                React.createElement(Col, { xs: 12, xl: 8 },
                    React.createElement(SwitchRoundFlagFinalized, { round: round, handlePatchRound: props.handlePatchRound }))),
            React.createElement(Row, { gutter: 12 },
                React.createElement(Col, { xs: 12, xl: 16, style: { textAlign: 'right' } },
                    React.createElement(Tooltip, { title: 'Publishing scores for a round allows athletes and spectators to see the scores and its live updates' },
                        React.createElement("h4", { style: { display: 'inline' } },
                            "Publish Scores ",
                            React.createElement(Icon, { type: 'question-circle-o', className: tableStyles.headerIcon })))),
                React.createElement(Col, { xs: 12, xl: 8 },
                    React.createElement(SwitchRoundFlagVisible, { round: round, handlePatchRound: props.handlePatchRound })))))
        : (React.createElement("p", null, "Round has not been created"));
};
export default InputStatus;



//////////////////
// WEBPACK FOOTER
// ./src/pages/WorkspaceEvent/FormRoundPage/FormRound/InputStatus.tsx
// module id = 1190
// module chunks = 0